<template>
	<v-menu v-bind="menu">
		<template #activator="{ on }">
			<slot name="activator" :on="on">
				<v-btn class="activator" icon @click.stop v-on="on">
					<v-icon>{{ icon }}</v-icon>
				</v-btn>
			</slot>
		</template>

		<v-list>
			<v-list-item
				v-for="(item, i) in items"
				:key="i"
				dense
				v-bind="item.props"
				@click="handleAction(item)"
			>
				<v-list-item-title v-text="item.title" />
			</v-list-item>
		</v-list>
	</v-menu>
</template>

<script>
// Menu Item Structure:
// {
// 	title: String,
// 	action: Function,
// 	props: Object, // v-list-item props
// }

export default {
	props: {
		icon: String,
		items: Array,
		menu: {
			type: Object,
			default: () => ({
				bottom: true,
				left: true,
			}),
		},
	},

	methods: {
		handleAction(item) {
			this.$emit("click:item", item);
			if (typeof item.action === "function") {
				item.action();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
</style>
